import { apiClient } from './client';
import { API_ROUTES } from './routes';

export const editorService = {
  async getEditorData(jobId) {
    const response = await apiClient.get(API_ROUTES.EDITOR.GET(jobId));
    return response?.data || null;
  },

  async saveEditorData(jobId, data) {
    // Send data directly with skeleton, words, phrases at root level
    // Backend Pydantic model expects { skeleton, words, phrases, settings, translation_data }
    const payload = {
      skeleton: data.skeleton || [],
      words: data.words || [],
      phrases: data.phrases || [],
      settings: data.settings || null,
      translation_data: data.translation_data || null
    };
    const response = await apiClient.put(API_ROUTES.EDITOR.SAVE(jobId), payload);
    return response?.data || null;
  },

  async updateSettings(jobId, settings) {
    const response = await apiClient.put(API_ROUTES.EDITOR.SETTINGS(jobId), settings);
    return response?.data || null;
  },

  async exportCaptions(jobId, format, { showPunctuation = true } = {}) {
    const response = await apiClient.post(
      API_ROUTES.EDITOR.EXPORT(jobId),
      { format, show_punctuation: showPunctuation },
      { responseType: 'blob' }
    );
    const disposition = response?.headers?.['content-disposition'] || '';
    const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
    const filename = filenameMatch ? filenameMatch[1] : null;
    return {
      blob: response?.data || null,
      filename,
      contentType: response?.headers?.['content-type'] || 'application/octet-stream',
    };
  },

  async getAudioUrl(jobId) {
    const response = await apiClient.get(API_ROUTES.EDITOR.AUDIO(jobId));
    return response?.data?.url || null;
  },

  /**
   * Request translation for a job
   * Can only be called once per job
   * @param {string} jobId - The job ID
   * @param {string} language - Target language (only 'en' supported currently)
   * @returns {Promise<{message: string, status: string, job_id: string}>}
   */
  async requestTranslation(jobId, language = 'en') {
    const response = await apiClient.post(API_ROUTES.TRANSCRIPTIONS.TRANSLATE(jobId), { language });
    return response?.data || null;
  }
};
